export enum FreewallQueryParam {
    Cdn = 'cdn',
    AdId = 'aid',
    ConfigId = 'cid'
}
